import angular from 'angular'
import controller from './login.controller'
import template from './login.html'
import resetCtrl from './reset/reset.ctrl'
import resetTpl from './reset/reset.html'

export default angular.module('login', ['ui.router'])
  .config(function ($httpProvider, $stateProvider) {
    'ngInject'
    $stateProvider.state('app.login', {
      url: '/login/:create/:pipeline?email&stageid&companyeor&jobid',
      params: { create: { squash: true, value: null }, pipeline: { squash: true, value: null } },
      resolve: {
        branchData: ($stateParams, $window, $cookies) => {
          'ngInject'

          return new Promise(resolve => {
            if (!$window.branch) return resolve(null)

            $window.branch.init(CONFIG.BRANCH_KEY, (err, res) => {
              if (err) {
                console.log(err)
                return resolve(null)
              }

              if (res.data_parsed.referrerCode) {
                $cookies.put('referrerCode', res.data_parsed.referrerCode)
              }
              if (res.data_parsed.inviteCompanyType) {
                $cookies.put('inviteCompanyType', res.data_parsed.inviteCompanyType)
              }
              if (res.data_parsed.pipelineId) {
                $cookies.put('pipelineId', res.data_parsed.pipelineId)
              }

              return resolve(res.data_parsed)
            })
          })
        },
        pipelineData: ($stateParams) => {
          'ngInject'
          return $stateParams
        }
      },
      views: {
        content: {
          template,
          controller,
          controllerAs: 'l'
        }
      }
    })
    // Handle legacy password resets
    // Retaining this route mainly so developers have an easy way to reset their legacy password, if needed.
    // NOTE: All buttons to trigger a legacy password reset have been "removed" (modified to give different instructions)
    // but a legacy password reset can still be triggered by sending a cURL request to the api-v1 password reset endpoint
    .state('app.reset', {
      url: '/reset?auth',
      resolve: {
        username: (Users, $stateParams, $mdDialog, $state) => {
          'ngInject'

          return Users.checkToken({tempAuthToken: $stateParams.auth})
          .catch((err) => {
            if (!err.data) return $state.go('app.login')
            let error = err.data.reason
            if (err.data.reason === 'Invalid token.') {
              error = 'Password reset link is invalid or has already been set, please try reseting your password or logging in on the next page'
            }
            $mdDialog.show(
              $mdDialog.alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(true)
                .title('Activation Error')
                .textContent(error)
                .ariaLabel('Password Reset Error')
                .ok('OK')

            )
            .onRemoving($state.go('app.login', {}, { reload: true }))
          })
        }
      },
      views: {
        content: {
          controller: resetCtrl,
          template: resetTpl,
          controllerAs: 'r'
        }
      }
    })
  })